import "./App.css";
import Footer from "./components/Footer/Footer";

import Hero from "./components/Hero/Hero";
import Join from "./components/Join/Join";
import Plans from "./components/Plans/Plans";
import Programs from "./components/Programs/Programs";
import Reasons from "./components/Reasons/Reasons";
import Testimonials from "./components/Testimonials/Testimonials";

import hero_image0 from "./assets/compressed_hero_image0.png";
// import hero_image1 from "../../assets/hero_image1.png"
import hero_image2 from "./assets/compressed_hero_image2.png";
import hero_image_back1 from "./assets/hero_image_back1.png";
import hero_image_back2 from "./assets/hero_image_back2.png";
import { useEffect } from "react";

function App() {
  useEffect(() => {
    let hero = [];
    hero[0] = new Image();
    hero[0].src = hero_image0;
    hero[1] = new Image();
    hero[1].src = hero_image2;
    hero[2] = new Image();
    hero[2].src = hero_image_back1;
    hero[3] = new Image();
    hero[3].src = hero_image_back2;
  }, []);
  return (
    <div className="App">
      <Hero />
      <Programs />
      <Reasons />
      <Plans />
      <Testimonials />
      <Join />
      <Footer />
    </div>
  );
}

export default App;
